import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "Name", -1)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", null, "Video ID", -1)
const _hoisted_9 = { class: "form-group grid" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", null, "내용", -1)
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", null, "노출 순서", -1)
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "col-sm-9" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", null, "Show view count", -1)
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "col-sm-9" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", null, "Show this video", -1)
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_26 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")
  const _component_file_upload = _resolveComponent("file-upload")
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fishingTube.name = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.fishingTube.name]
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.fishingTube.video_id = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.fishingTube.video_id]
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_editor, {
                ref: "customEditor",
                "set-contents": _ctx.fishingTube.desc
              }, null, 8, ["set-contents"])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.fishingTube.order = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.fishingTube.order]
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("div", _hoisted_17, [
                  _createVNode("label", _hoisted_18, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.fishingTube.show_view_count = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.fishingTube.show_view_count]
                    ]),
                    _hoisted_19
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode("div", _hoisted_23, [
                  _createVNode("label", _hoisted_24, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.fishingTube.show = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.fishingTube.show]
                    ]),
                    _hoisted_25
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode(_component_file_upload, {
                ref: "thumbnailFile",
                "folder-name": 'fishing-tubes'
              }, null, 512)
            ])
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "생성",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 32)
    ])
  ]))
}